import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '../../../../../types';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-core-menu-vertical-section]',
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss',
  standalone: false
})
export class CoreMenuVerticalSectionComponent {
  @Input()
  public item!: CoreMenuItem;
}
